export const COMMON_UI_I18N_FOLDER_STATUS_MESSAGES = {
	trash: {
		infoMessage:
			"Les dossiers supprimés peuvent être restaurés à tout moment. Ils ne sont pas définitivement supprimés.",
	},
	deletion: {
		softDeleteWarning: "⚠️ Cette action placera le dossier dans la corbeille.",
		retentionMessage: "Le dossier reste dans la corbeille pendant 90 jours avant suppression définitive.",
		irreversibleMessage:
			"Cette action est irréversible. En supprimant ce dossier, toutes les informations associées seront définitivement perdues.",
		errorMessage: "Impossible de supprimer le dossier",
		confirmationInputLabel: "Numéro du dossier (répétez ci-dessus)",
		confirmationErrorPrefix: 'Veuillez saisir exactement le numéro du dossier "',
		confirmationErrorSuffix: '" pour confirmer.',
	},
	retention: {
		dateLabel: "Suppression automatique des fichiers du dossier prévue le :",
		datePastMessage: "Date dépassée : les fichiers peuvent être supprimés lors d'une prochaine mise à jour du service.",
		alertTitle: "Conservation des fichiers",
		alertBody:
			"Il reste moins d'un mois avant la suppression automatique des fichiers du dossier. Pour les conserver, lancez l'archivage longue durée.",
	},
	longTermArchive: {
		inProgress: "Archivage en cours…",
		pollHint: "Le statut se met à jour automatiquement.",
		completed: "Archivage terminé. Les documents sont disponibles dans l’espace d’archivage longue durée.",
		readOnlyWhilePending: "Le dossier est en lecture seule pendant l’archivage. Aucune action sur les documents n’est possible.",
		readOnlyWhenReady: "Le dossier reste en lecture seule après l’archivage. Les participants externes n’y ont plus accès.",
		failedPrefix: "Archivage interrompu :",
	},
} as const;
